import { Flex, Formatters, NumberFormat, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { currencyCodeToSymbol, isAcceptedCurrencyCode } from '../../../../../../consts/currencyCodeToSymbol'

interface VatAmountDueProps {
  amountDue: number
}

export const VatAmountDue = ({ amountDue }: VatAmountDueProps): ReactElement => {
  const { organization } = useUserOrganization()

  const formattedAmountDue = amountDue
    ? NumberFormat.getFormattedNumber(amountDue, Formatters.getFormatLocale(organization?.localeId || 'nl_NL'))
    : '0'

  const currency = organization?.baseCurrencyId || 'EUR'
  const symbol = isAcceptedCurrencyCode(currency) ? currencyCodeToSymbol[currency] : {}

  const prefix = symbol.prefix ?? ''
  const suffix = symbol.suffix ?? ''

  return (
    <Flex alignItems="center" gap={Spacing.S4}>
      {prefix && <Text colorVariant="secondary">{prefix}</Text>}
      <Text variant="h1">{formattedAmountDue}</Text>
      {suffix && <Text colorVariant="secondary">{suffix}</Text>}
    </Flex>
  )
}
